var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatusLabel',{staticClass:"py-3 tournament-card_status-label",attrs:{"status":_vm.tournament.status,"is-admin":_vm.isOrganizer,"for-tournament":""}})}
var staticRenderFns = []

export { render, staticRenderFns }